// src/programEveniment.js
// Client pentru endpoint-ul care intoarce programul dedus al unui eveniment:
// zilele de pontaj si orele/zi, calculate in fusul tenantului (BE = sursa de
// adevar). Frontendul NU mai calculeaza turele local.
import { fetchUtils } from "react-admin";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

/**
 * @param {number|string} evenimentId
 * @returns {Promise<{ fusOrar: string, orePeZi: number, zile: {data: string, orePeZi: number}[] }>}
 */
export const fetchProgramEveniment = async (evenimentId) => {
    const token = localStorage.getItem("token");
    const headers = new Headers({ Accept: "application/json" });
    if (token) headers.set("Authorization", `Bearer ${token}`);

    const { json } = await fetchUtils.fetchJson(
        `${API_URL}/evenimente/${evenimentId}/program`,
        { headers }
    );
    return json;
};
